// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__qcanF","content":"style_content__R+31X","button":"style_button__GGMgk"};